module.exports = __webpack_public_path__ + "static/media/news.e4d464f5.svg";